import { render } from "./ChannelCheckout.vue?vue&type=template&id=1fafbdb2&scoped=true"
import script from "./ChannelCheckout.vue?vue&type=script&lang=js"
export * from "./ChannelCheckout.vue?vue&type=script&lang=js"

import "./ChannelCheckout.vue?vue&type=style&index=0&id=1fafbdb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fafbdb2"]])

export default __exports__